import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { UntouchOnFocusoutDirective } from './directives/clear-touch-error.directive';
import { ErrorDirective } from './directives/error.directive';
import { HintDirective } from './directives/hint.directive';
import { InputDirective } from './directives/input.directive';
import { LabelDirective } from './directives/label.directive';
import { PlaceholderDirective } from './directives/placeholder.directive';
import { PrefillDirective } from './directives/prefill.directive';
import { PrefixDirective } from './directives/prefix.directive';
import { SuffixDirective } from './directives/suffix.directive';

@NgModule({
    declarations: [
        InputDirective,
        UntouchOnFocusoutDirective,
        PrefillDirective,
        ErrorDirective,
        HintDirective,
        LabelDirective,
        PlaceholderDirective,
        PrefixDirective,
        SuffixDirective,
        FormFieldComponent
    ],
    imports: [CommonModule, ObserversModule],
    exports: [
        InputDirective,
        UntouchOnFocusoutDirective,
        PrefillDirective,
        ErrorDirective,
        HintDirective,
        LabelDirective,
        PlaceholderDirective,
        PrefixDirective,
        SuffixDirective,
        FormFieldComponent
    ]
})
export class FormFieldModule {}
